import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=cd26962a&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd26962a')) {
      api.createRecord('cd26962a', component.options)
    } else {
      api.reload('cd26962a', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=cd26962a&", function () {
      api.rerender('cd26962a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HKG2OPqc1T14/JS/comp/ErrorMessage.vue"
export default component.exports